import {Component, OnInit} from '@angular/core';
import {ApplicationContextService} from '../../../../core/services/impl/configuration/application-context.service';
import {SessionStorage} from '../../../../core/services/global/storage/session-storage.service';
import {UrlParamsService} from '../../../../core/services/impl/url-params.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ApplicationStateService} from '../../../services/application-state.service';
import {AppMode} from '../../../models/app-mode.enum';
import {ScrollHelper} from '../../../services/scroll-helper';
import {
  NextNotificationButtonAction,
  NextNotificationButtonConfig,
  NextNotificationState
} from '../../../models/notification-state';
import {NotificationStateService} from '../../../services/notification-state.service';
import {QueryParamName} from '../../../../core/enums/query-param-name.enum';

@Component({
  selector: 'app-next-success-notification',
  templateUrl: './next-success-notification.component.html',
  styleUrls: []
})
export class NextSuccessNotificationComponent implements OnInit {

  state: NextNotificationState;
  otherProductsTitle: string;

  constructor(private contextService: ApplicationContextService,
              private urlParamsService: UrlParamsService,
              private route: ActivatedRoute,
              private router: Router,
              private notificationStateService: NotificationStateService,
              private stateService: ApplicationStateService,
              private sessionStorage: SessionStorage) { }

  ngOnInit() {
    this.init();
    setTimeout(() => (new ScrollHelper()).scrollToTop(), 0);
  }

  handleAction(buttonConfig: NextNotificationButtonConfig): void {
    switch (buttonConfig.action) {
      case NextNotificationButtonAction.RESET_APP:
        this.reset();
        break;
      case NextNotificationButtonAction.REDIRECT:
        window.open(buttonConfig.redirectUrl, '_blank');
        break;
      default:
        console.warn(`Notification button action ${buttonConfig.action} not supported.`);
    }
  }

  reset(): void {
    this.stateService.mode = AppMode.NOTIFICATIONS;
    const context = this.urlParamsService.getQueryParam(QueryParamName.CONTEXT);
    this.sessionStorage.clear();
    this.router.navigate(['/'], {
      queryParams: {
        [QueryParamName.CONTEXT]: context
      },
      relativeTo: this.route
    });
    setTimeout(() => window.location.reload(), 0);
  }

  private init(): void {
    this.state = this.notificationStateService.nextNotificationState;
    this.otherProductsTitle = this.contextService.isDiagnosticStationContext ? 'NEXT_OTHER_PRODUCTS.DIAGNOSTIC_STATION_TITLE' : 'NEXT_OTHER_PRODUCTS.TITLE';
  }
}
